// Clinic Configuration for Dentist in Greenville
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Greenville",
  clinicId: "dentistingreenville",
  clinicUrl: "https://dentistingreenville.com",

  // Contact Information
  phoneNumber: "(864) 284-0066",
  phoneNumberRaw: "+18642840066", // For tel: and sms: links
  email: "dentalcare@dentistingreenville.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistingreenville&agentId=ad1be0d0-fc61-4ab8-bee9-7f8b684196e6",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistingreenville/voice",

  // Location
  address: "4 Market Point Dr Suite E, Greenville, SC 29607, United States",
  addressShort: "4 Market Point Dr Suite E, Greenville, SC 29607",
  city: "Greenville",
  hcity: "Greenville",
  state: "South Carolina",
  stateShortForm: "SC",
  PostalCode: "29607",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/uSjmEpB96DkWds85A",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.7881976580125!2d-82.2996522!3d34.8258343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8858298d6b9f4a75%3A0x9487872bb0380334!2sDentist%20in%20Greenville!5e1!3m2!1sen!2sin!4v1759836322477!5m2!1sen!2sin',
  iframeTitle: "Dentist in Greenville",

  //membership
  membership: "https://member.kleer.com/?slug=WG7F",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinGreenville",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-greenville?utm_source=practice&utm_medium=email&m=65983",


  // Analytics
  clarityProjectId: "prc4w966rh",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistingreenville",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistingreenville",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistingreenville",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/people/Dentist-in-Greenville/61560717845933/",
    instagram: "https://www.instagram.com/dentistingreenville/",
    twitter: "https://x.com/Dent_Greenville",
    linkedin: "https://www.linkedin.com/company/dentist-in-greenville/",
    youtube: "https://www.youtube.com/@DentistGreenville",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 10,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 23,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 10, // DEFAULT_OP_NUM
      AppointmentTypeNum: 23,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 10, // DEFAULT_OP_NUM
      AppointmentTypeNum: 23,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
